import Image from 'next/image';
import React from 'react';

import DgMuthootEximNewLogo from '@/assets/images/icons/DgMuthootEximNewLogo.svg';

export const DgPoweredBy = () => {
  return (
    <div className="dg-new-powered-by-container">
      <p className="dg-new-powered-by-text text--black">
        Powered by Muthoot Exim Pvt. Ltd.
      </p>
      <span className="dg-new-powered-line"></span>

      <Image
        style={{ color: undefined }}
        className="dg-new-exim-logo"
        src={DgMuthootEximNewLogo}
        alt="muthoot exim logo"
      />
    </div>
  );
};
